module.exports = __webpack_public_path__ + "img/34f-config-modelos-doc-wizard-irregularidades.5ddbef33.png";